import { prepareAttributionRows, type AttributionRow } from './goalMetrics';
import { EmptyPanel } from './EmptyPanel';
import styles from './AttributionBars.module.css';

type Props = {
  rows: AttributionRow[];
  emptyTitle: string;
  emptyDescription: string;
};

export function AttributionBars({ rows, emptyTitle, emptyDescription }: Props) {
  const { items, other, total } = prepareAttributionRows(rows);

  if (total === 0) {
    return <EmptyPanel title={emptyTitle} description={emptyDescription} />;
  }

  const maxC = items[0]?.c ?? 1;

  return (
    <ul className={styles.list}>
      {items.map((r) => (
        <li key={r.source} className={styles.row}>
          <div className={styles.labelRow}>
            <span className={styles.source}>{r.source || '—'}</span>
            <span className={styles.meta}>
              {r.c} · {r.pct}%
            </span>
          </div>
          <div className={styles.track}>
            <div
              className={styles.fill}
              style={{ width: `${maxC > 0 ? (r.c / maxC) * 100 : 0}%` }}
            />
          </div>
        </li>
      ))}
      {other > 0 ? (
        <li className={styles.other}>
          Overig · {other} ({Math.round((other / total) * 1000) / 10}%)
        </li>
      ) : null}
    </ul>
  );
}
